import { useCallback, useMemo } from 'react';
import type { JSONSerializableObject } from '../../utils/json-types';
import { useFetchFromApi } from './use-fetch-from-api';
import { useUpdateUserInformation } from './types/user-information-from-api';
import type { IUserInformationFromApi } from '../../slices/user';

/** Undo future withdraw. */
export const usePostWithdrawUndo = () => {
  const {
    data, error, loading, doRequest,
  } =
    useFetchFromApi<IUserInformationFromApi>({
      relativeApiUrl: '/election/withdraw/undo',
      method: 'POST',
      initialLoadingValue: false,
    });

  const { updateData, processResponse } = useUpdateUserInformation();

  const sendRequest = useCallback(
    (shouldUpdateDataAfterRequest?: boolean) => {
      doRequest({}, (responseData: JSONSerializableObject) =>
        processResponse(responseData, shouldUpdateDataAfterRequest));
    },
    [doRequest, processResponse],
  );

  const updateDataAfterRequest = useCallback(() => {
    if (data) {
      updateData(data);
    }
  }, [data, updateData]);

  return useMemo(
    () => ({
      data,
      error,
      loading,
      sendRequest,
      updateDataAfterRequest,
    }),
    [data, error, loading, sendRequest, updateDataAfterRequest],
  );
};
